import { FuelTransaction } from '@/src/types/FuelTransaction';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { useFuelTransaction } from '../hooks/useFuelTransaction';
import { Dialog } from '../../ui/Dialog';
import { getFormattedDate } from '../../../lib/dateUtils';
import { toast } from 'react-toastify';
import { Role } from '../../../types/Role';
import { UserContext } from '../../../context/UserProvider';
import { Button } from '../../ui/Button';

export const DeleteFuelTransaction = ({ fuelTransaction }: { fuelTransaction: FuelTransaction }) => {
    const { userRole } = useContext(UserContext);
    const [isOpen, setIsOpen] = useState(false);
    const deleteMutation = useFuelTransaction().deleteFuelTransaction();

    const handleDelete = (fuelTransaction: FuelTransaction) => {
        deleteMutation.mutate(fuelTransaction.id, {
            onSuccess: () => {
                setIsOpen(false);

                if (userRole === Role.ADMIN) toast('Tankbeurt succesvol verwijderd.');
            },
        });
    };

    return (
        <>
            <Button.Icon onClick={() => setIsOpen(true)} aria-label="delete" title="Verwijderen">
                <FontAwesomeIcon icon={faTrashCan} className="text-lg" />
            </Button.Icon>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <>
                    <Dialog.Title>Tankbeurt verwijderen</Dialog.Title>
                    <div className="my-4">
                        Weet je zeker dat je de tankbeurt op <b>{`${getFormattedDate(fuelTransaction.transactionDate)}`}</b> wilt verwijderen?
                    </div>
                    <div className="flex justify-end">
                        <Button onClick={() => handleDelete(fuelTransaction)} loading={deleteMutation.isPending}>
                            Verwijderen
                        </Button>
                    </div>
                </>
            </Dialog>
        </>
    );
};
